import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { admin, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/loginmanage" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/loginmanage");
    } catch {
      toast.error("Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-header px-4">
      <div className="w-full max-w-sm">
        <div className="text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-boomerang/15 ring-1 ring-boomerang/30"><Lock className="h-6 w-6 text-boomerang" /></div>
          <h1 className="mt-4 font-display text-2xl text-white">Kentucky Hub Admin</h1>
          <p className="mt-1 text-sm text-white/60">Analytics &amp; store insights</p>
        </div>
        <form onSubmit={onSubmit} data-testid="admin-login-form" className="mt-8 space-y-4 rounded-xl border border-white/12 bg-white/[0.04] p-6">
          <div>
            <label htmlFor="email" className="mb-1.5 block text-sm font-medium text-white/80">Email</label>
            <input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-md border border-white/20 bg-white/5 px-3 py-2.5 text-sm text-white placeholder:text-white/40 outline-none focus:border-boomerang focus:ring-2 focus:ring-boomerang/40"
              placeholder="admin@boomerang.ie" data-testid="admin-email-input" />
          </div>
          <div>
            <label htmlFor="password" className="mb-1.5 block text-sm font-medium text-white/80">Password</label>
            <input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-md border border-white/20 bg-white/5 px-3 py-2.5 text-sm text-white placeholder:text-white/40 outline-none focus:border-boomerang focus:ring-2 focus:ring-boomerang/40"
              placeholder="Enter your password" data-testid="admin-password-input" />
          </div>
          <Button type="submit" className="w-full" disabled={loading} data-testid="admin-login-submit-button">
            {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Signing in…</> : "Sign in"}
          </Button>
        </form>
        <p className="mt-4 text-center text-xs text-white/40">Authorised access only · Boomerang.ie</p>
      </div>
    </div>
  );
}
